import transferVoiceCallContent from './TransferVoiceCallContent';

const transferVoiceCall = {
  name: 'Transfer Voice Call',
  Content: transferVoiceCallContent,
  setInitialContent: (content = {}) => {
    return {
      transferTarget: content.transferTarget || ''
    };
  },
  valid: () => {
    return true;
  }
};

export default transferVoiceCall;
